<template>
    <div
        @click="btnClicked"
        @animationend="animationEnd"
    >
        <div class="icon-refresh" :class="{'is-clicked': refreshBtnClicked}"  @animationend="iconAnimationEnd">
            <svg aria-hidden="true" data-prefix="fas" data-icon="redo-alt" class="svg-inline--fa fa-redo-alt fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                <path fill="#333333" d="M256.455 8c66.269.119 126.437 26.233 170.859 68.685l35.715-35.715C478.149 25.851 504 36.559 504 57.941V192c0 13.255-10.745 24-24 24H345.941c-21.382 0-32.09-25.851-16.971-40.971l41.75-41.75c-30.864-28.899-70.801-44.907-113.23-45.273-92.398-.798-170.283 73.977-169.484 169.442C88.764 348.009 162.184 424 256 424c41.127 0 79.997-14.678 110.629-41.556 4.743-4.161 11.906-3.908 16.368.553l39.662 39.662c4.872 4.872 4.631 12.815-.482 17.433C378.202 479.813 319.926 504 256 504 119.034 504 8.001 392.967 8 256.002 7.999 119.193 119.646 7.755 256.455 8z"></path>
            </svg>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'refresh-button',
        props: {
            clickHandler: Function,
        },
        data() {
            return {
                refreshBtnClicked: false,
            }
        },
        methods: {
            animationEnd($event) {
                this.$emit('refresh-btn-bottom', $event);
            },
            btnClicked() {
                if (this.clickHandler) {
                    this.clickHandler();
                }
                this.refreshBtnClicked = true;
            },
            iconAnimationEnd($event) {
                this.refreshBtnClicked = false;
                this.$emit('refresh-icon-end', $event);
            }
        }
    }

</script>

<style lang="scss" scoped>

    .refresh-btn {
        position: absolute;
        top: calc(50% - 70px);
        left: calc(50% - 70px);
        bottom: auto;
        align-items: center;
        background-color: #FFFFFF;
        border-radius: 50%;
        width: 140px;
        height: 140px;
        text-align: center;
        z-index: 1;
        padding: 35px;
        cursor: pointer;
        transform: scale(1);
        animation: btn-pulsate 3000ms infinite;
        transition: all 1000ms ease-out;

        &.next {
            box-shadow: 0px 1px 20px 5px rgba(0, 0, 0, 0.3);
            animation: btn-down 1200ms linear forwards;
            animation-delay: 800ms;
        }

        .icon-refresh {
            width: 70px;
            height: 70px;
            &.is-clicked {
                animation: btn-icon-rotate 500ms linear forwards;
            }
        }

    }

    @keyframes btn-pulsate {
        0% {
            transform: scale(1);
            box-shadow: 0;
        }

        25% {
             transform: scale(1.1);
             box-shadow: 0px 1px 20px 5px rgba(0, 0, 0, 0.3)
        }

        100% {
            transform: scale(1);
            box-shadow: 0;
        }
    }

    @keyframes btn-down {
        0% {
            top: 50%;
            transform: scale(1);
        }

        50% {
            top: 100%;
            transform: translateY(-70px) scale(0.60) rotate(0deg);
        }

        100% {
            top: 100%;
            transform: translateY(-70px) scale(0.60) rotate(360deg);
        }
    }

    @keyframes btn-attention {
        0% {
            transform: rotate(0deg) scale(1);
            box-shadow: 0;
        }

        25% {
             transform: rotate(360deg) scale(1.1);
             box-shadow: 0px 1px 20px 5px rgba(0, 0, 0, 0.3)
        }

        100% {
            transform: scale(1);
            box-shadow: 0;
        }
    }

    @keyframes btn-icon-rotate {
        0% {
            transform: rotate(0deg);
        }

        100% {
            transform: rotate(360deg);
        }
    }



</style>